class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.modalDialog = this.closest('dialog');
  }

  async handleCartUpdate(productId) {
    let recommendUrl = this.dataset.url;
    if (!productId || !recommendUrl) {
      console.error('Product id is not found or URL is invalid');
      return;
    }
    recommendUrl = recommendUrl.replace('@product_id@', productId);

    await this.fetchRecommendations(recommendUrl);

    if (this.modalDialog) {
      const openedDialog = document.querySelector('dialog[open]');
      if(openedDialog && typeof openedDialog.close === 'function') {
        document.body.classList.remove("overflow-hidden");
        openedDialog.close();
      }

      this.modalDialog.open();
    } else {
      console.warn("Modal dialog is not defined");
    }
  }

  async fetchRecommendations(recommendUrl) {
    if (!recommendUrl) {
      console.warn("recommendUrl is not defined");
      return;
    }

    try {
      const response = await fetch(recommendUrl);
      
      const text = await response.text();

      const tempContainer = document.createElement("div");
      tempContainer.innerHTML = text;

      const recommendations = tempContainer.querySelector(".js-product-recommendations");
      const elToUpdate = this.querySelector(".js-product-recommendations");

      if (recommendations && recommendations.innerHTML.trim().length) {
        elToUpdate.innerHTML = recommendations.innerHTML;
      }
    } catch (error) {
      console.error("Failed to fetch recommendations:", error);
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define('cart-notification', CartNotification);